import { Flex, Loader } from '@fluentui/react-northstar'
import React from 'react'

const CenterLoader = () => {
    return <Flex vAlign='center' hAlign='center' style={{ height: "100vh", backgroundColor: "transparent" }}>
        <Loader />
    </Flex>
}

export default CenterLoader